"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.vehicleUtils = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ZIP_CODE = 'zipCode';
var getModelYearsMap = function getModelYearsMap(modelYears) {
  return modelYears && modelYears.reduce(function (map, year) {
    var _objectSpread2;
    return _objectSpread(_objectSpread({}, map), {}, (_objectSpread2 = {}, _objectSpread2[year.id] = false, _objectSpread2));
  }, {});
};
var getSelectedYear = function getSelectedYear(years) {
  if (!years) return null;
  var selectedYears = [];
  Object.entries(years).forEach(function (_ref) {
    var key = _ref[0],
      value = _ref[1];
    return value && selectedYears.push(key);
  });
  return selectedYears;
};
var getDisclaimer = function getDisclaimer(disclaimers, associated) {
  if (!disclaimers) return null;
  var index = disclaimers.findIndex(function (item) {
    return item.associated === associated;
  });
  return index !== -1 ? disclaimers[index].disclaimerNumber : '';
};
var vehicleUtils = {
  getSelectedYear: getSelectedYear,
  ZIP_CODE: ZIP_CODE,
  getModelYearsMap: getModelYearsMap,
  getDisclaimer: getDisclaimer
};

// eslint-disable-next-line import/prefer-default-export
exports.vehicleUtils = vehicleUtils;